import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from '../../../lib/moment.js'

import { Button } from 'reactstrap'
import { authSelector, companySelector } from './../../../selectors'
import { companyAction } from './../../../actions/'
import CompanyForm from '../../../components/company'
import CustomModalMessage from '../../../components/modal-message'

class EditCompany extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      company_code: '',
      company: '',
      edit: false,
      id: '',
      activeTab: '1',
      is_active: true,
      start_date: '',
    }
    this.handleInput = this.handleInput.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
    this.deactivateCompany = this.deactivateCompany.bind(this)
  }
  componentDidMount() {
    if (get(this.props, 'edit.edit')) {
      this.props.getCompany(get(this.props, 'edit.id'), localStorage.getItem('access_token'))
    }
  }
  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'companyGet')) {
      this.setState({
        company_code: get(nextProps, 'companyGet.company_code'),
        company: get(nextProps, 'companyGet.name'),
        start_date: get(nextProps, 'companyGet.start_date') ? get(nextProps, 'companyGet.start_date') : '',
        is_active: get(nextProps, 'companyGet.is_active'),
      })
      this.props.resetGetCompany()
    }
    if (get(nextProps, 'edit')) {
      if (get(nextProps, 'edit.edit')) {
        this.setState({ id: get(nextProps, 'edit.id') })
        this.props.handleClickEdit(false, '')
        this.props.getCompany(get(nextProps, 'edit.id'), localStorage.getItem('access_token'))
        this.props.resetGetCompany()
      }
      this.setState({
        edit: false,
      })
    }
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleClickEdit() {
    this.setState({ edit: true })
  }
  deactivateCompany() {
    this.props.deactivateCompany(get(this.state, 'id'), localStorage.getItem('access_token'))
  }
  handleDelete() {
    this.deactivateCompany()
    this.props.cancelDelete()
    this.props.handleSpan(false)
  }
  handleDiscard() {
    this.props.cancelDiscard()
    this.props.handleSpan(false)
  }
  submitForm() {
    if (get(this.state, 'edit')) {
      this.props.editCompany(
        get(this.state, 'id'),
        {
          company_code: this.state.company_code,
          name: this.state.company,
          start_date: new moment(this.state.start_date),
          is_active: this.state.is_active,
        },
        localStorage.getItem('access_token'))
    }
  }
  render() {
    const button = (
      <div>
        <NewButton outline color="danger" onClick={ () => this.props.showDelete('confirmDelete') }>Delete</NewButton>
        <NewButton color="success" onClick={ this.state.edit ? this.submitForm : this.handleClickEdit }>{ this.state.edit ? 'Save' : 'Edit' }</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    return (
      <div>
        {
          get(this.props, 'confirmType') === 'confirmDelete' &&
          <CustomModalMessage
            hide={ this.props.cancelDelete }
            show={ get(this.props, 'confirmType') === 'confirmDelete' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDelete }
          />
        }
        {
          get(this.props, 'confirmType') === 'confirmDiscard' &&
          <CustomModalMessage
            hide={ this.props.cancelDiscard }
            show={ get(this.props, 'confirmType') === 'confirmDiscard' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDiscard }
          />
        }
        <CompanyForm
          edit={ this.state.edit }
          submitForm={ this.submitForm }
          handleClickEdit={ this.handleClickEdit }
          handleSpan={ this.props.handleSpan }
          company_code={ this.state.company_code }
          company={ this.state.company }
          handleInput={ this.handleInput }
          button={ button }
          confrim={ get(this.props, 'confirm') }
          cancelForm={ this.props.cancelForm }
          showDiscard={ this.state.edit ? this.props.showDiscard : () => this.props.handleSpan(false) }
          start_date={ this.state.start_date }
          is_active={ this.state.is_active }
        />
      </div>
    )
  }
}

EditCompany.propTypes = {
  editCompany: PropTypes.func.isRequired,
  getCompany: PropTypes.func.isRequired,
  resetGetCompany: PropTypes.func.isRequired,
  handleClickEdit: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
  deactivateCompany: PropTypes.func.isRequired,
  cancelDelete: PropTypes.func.isRequired,
  showDelete: PropTypes.func.isRequired,
  cancelDiscard: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getUserData,
  companyCreate: companySelector.getCreateCompanyData,
  companyEdit: companySelector.getEditCompanyData,
  companyGet: companySelector.getGetCompanyData,
  companyDeactivate: companySelector.getDeactivateCompanyData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  createCompany: companyAction.createCompany,
  resetCreateCompany: companyAction.resetCreateCompany,
  editCompany: companyAction.editCompany,
  resetEditCompany: companyAction.resetEditCompany,
  getCompany: companyAction.getCompanyByID,
  resetGetCompany: companyAction.resetGetCompany,
  listCompany: companyAction.getCompany,
  deactivateCompany: companyAction.deactivateCompany,
  resetDeactivateCompany: companyAction.resetDeactivateCompany,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(EditCompany)

const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`



// WEBPACK FOOTER //
// ./src/pages/company/edit/index.js